import { render } from "./TheBreadcrumbInstanz.pug?vue&type=template&id=55ce72c0&lang=pug"
import script from "./TheBreadcrumbInstanz.js?vue&type=script&lang=js"
export * from "./TheBreadcrumbInstanz.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__